/* Componsables */
import Vue from 'vue'
import Vuex from 'vuex'

/* Services */
import { loginFB } from '../services/ServFB.js'

/* i18n */
import { setLocaleFromIso3 } from '../i18n'

/* Fonts */
import { cssFontFamilyValue, cssFontWeightValue, loadGoogleFontsFromTemplate } from '../helpers/templateGoogleFonts'
import { maybeInjectGoogleTagManagerForOwner } from '../helpers/googleTagManager'

const lFB = new loginFB()

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    template: {},
    config: {},
    subdomain: '',
    domain: '',
    ownerId: null,
    registrationObject: {},
    phoneFromCpfVerification: '',
    registrationErrors: [],
    sso: false,
    oidcParams: {},
    recoveryDestination: '',
    loginByRegistration: false,
    isEmailSentDirect: false,
    identity: null,
    emailToSendConfirmateCode: null,
    countries: [],
    selectedCountryId: null,
    showInputCheckEmailGuardian: false,
    guardianCreationFinished: false,
    copyLoginPayload: null,
  },
  mutations: {
    SET_template(state, data) {
      state.config = data.config
      state.template = data.template
      state.ownerId = data.ownerId != null ? data.ownerId : data.config && data.config.ownerId

      setLocaleFromIso3(data.config && data.config.iso3)

      loadGoogleFontsFromTemplate(data.template)
      maybeInjectGoogleTagManagerForOwner(state.config && state.config.ownerId)

      document.documentElement.style.setProperty('--primary-color', data.template.primaryColor)
      document.documentElement.style.setProperty('--input-color', data.template.inputBorderColor)

      document.documentElement.style.setProperty(
        '--checkbox-color',
        data.template.checkBoxColor ? data.template.checkBoxColor : data.template.primaryColor,
      )

      document.documentElement.style.setProperty('--fallbackColor', data.template.bgFallbackColor)

      if (data.template.fontFamilyP) {
        document.documentElement.style.setProperty(
          '--font-family-p',
          cssFontFamilyValue(data.template.fontFamilyP),
        )
        const fontWeightP = cssFontWeightValue(data.template.fontFamilyP)
        if (fontWeightP) {
          document.documentElement.style.setProperty('--font-weight-p', fontWeightP)
        }
      }

      if (data.template.fontFamilyH1) {
        document.documentElement.style.setProperty(
          '--font-family-h1',
          cssFontFamilyValue(data.template.fontFamilyH1),
        )
        const fontWeightH1 = cssFontWeightValue(data.template.fontFamilyH1)
        if (fontWeightH1) {
          document.documentElement.style.setProperty('--font-weight-h1', fontWeightH1)
        }
      }

      if (data.template.fontFamilyTitles) {
        document.documentElement.style.setProperty(
          '--font-family-titles',
          cssFontFamilyValue(data.template.fontFamilyTitles),
        )
        const fontWeightTitles = cssFontWeightValue(data.template.fontFamilyTitles)
        if (fontWeightTitles) {
          document.documentElement.style.setProperty('--font-weight-titles', fontWeightTitles)
        }
      }

      if (data.template.fontFamilyGeneral) {
        document.documentElement.style.setProperty(
          '--font-family-general',
          cssFontFamilyValue(data.template.fontFamilyGeneral),
        )
        const fontWeightGeneral = cssFontWeightValue(data.template.fontFamilyGeneral)
        if (fontWeightGeneral) {
          document.documentElement.style.setProperty('--font-weight-general', fontWeightGeneral)
        }
      }

      if (data.template.homeTexts.mainTitleSize) {
        document.documentElement.style.setProperty(
          '--h1-size',
          data.template.homeTexts.mainTitleSize,
        )
      }
    },
    SET_SUBDOMAIN(state, value) {
      state.subdomain = value
    },
    SET_DOMAIN(state, value) {
      state.domain = value
    },
    setIdentity(state, value) {
      state.identity = value
    },
    setPhoneFromCpfVerification(state, value) {
      state.phoneFromCpfVerification = value
    },
    resetRegistrationObject(state) {
      state.registrationObject = {}
    },
    isEmailSentDirect(state, value) {
      state.isEmailSentDirect = value
    },
    emailToSendConfirmateCode(state, value) {
      state.emailToSendConfirmateCode = value
    },
    updateRegistrationObject(state, value) {
      const newObject = {
        ...state.registrationObject,
        ...value,
      }

      state.registrationObject = newObject
    },
    clearRegistrationErrors(state) {
      state.registrationErrors = []
    },
    addRegistrationError(state, value) {
      state.registrationErrors.push(value)
    },
    set_sso(state, value) {
      state.sso = value
    },
    setOidcParams(state, value) {
      state.oidcParams = value
    },
    setRecoveryDestination(state, value) {
      state.recoveryDestination = value
    },
    setLoginByRegistration(state, value) {
      state.loginByRegistration = value
    },
    SET_COUNTRIES(state, countries) {
      state.countries = countries
    },
    SET_SELECTED_COUNTRY_ID(state, countryId) {
      state.selectedCountryId = countryId
    },
    setShowInputCheckEmailGuardian(state, value) {
      state.showInputCheckEmailGuardian = value
    },
    setGuardianCreationFinished(state, value) {
      state.guardianCreationFinished = value
    },
    setCopyLoginPayload(state, value) {
      state.copyLoginPayload = value
    },
  },
  actions: {
    get_Template({ commit, state }) {
      lFB.getLoginConf(state.domain, state.subdomain).then(
        resp => {
          commit('SET_template', resp)
        },
        err => alert(err),
      )
    },
    validateOidcRequest({ commit }, oidcParams) {
      lFB
        .validateAuthorizeRequest(oidcParams)
        .then(() => {
          commit('setOidcParams', oidcParams)
        })
        .catch(err => alert(err))
    },
    setCountries({ commit }, countries) {
      commit('SET_COUNTRIES', countries)
    },
    setSelectedCountryId({ commit }, countryId) {
      commit('SET_SELECTED_COUNTRY_ID', countryId)
    },
  },
  getters: {
    primaryBtnStyle(state) {
      if (!state.template || Object.keys(state.template).length === 0) {
        return {}
      }

      return {
        backgroundColor: state.template.primaryBtn.bgColor,
        borderColor: state.template.primaryBtn.bgColor,
        color: state.template.primaryBtn.textColor,
        fontWeight: '600',
      }
    },
    secondaryBtnStyleTheme(state) {
      if (!state.template) return {}

      return {
        backgroundColor: state.template.secondaryBtn.bgColor,
        borderColor: state.template.secondaryBtn.borderColor,
        color: state.template.secondaryBtn.textColor,
        fontWeight: '600',
      }
    },
    secondaryBtnStyle(state) {
      if (!state.template) return {}

      return {
        backgroundColor: state.template.secondaryBtn.bgColor,
        borderColor: state.template.secondaryBtn.borderColor,
        color: state.template.secondaryBtn.textColor,
        fontWeight: '600',
      }
    },
    primaryColorText(state) {
      if (!state.template) return {}

      return {
        color: state.template.primaryColor,
      }
    },
    cardLogoWidth(state) {
      if (!state.template.cardLogoWidth) return '70px'

      return state.template.cardLogoWidth
    },
    headerLogoWidth(state) {
      if (!state.template.headerLogoWidth) return '140px'

      return state.template.headerLogoWidth
    },
    getCountries: state => state.countries,
    getSelectedCountryId: state => state.selectedCountryId,
  },
})
